function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request, useMutation, useQuery } from '@applyboard/ui-utils';
var GET_KYC_RESULTS_PATH = '/api/rpj/v1/kyc/details';
export var AB_STATUS_VALUES = Object.freeze({
  ALL: 'All',
  NEW: 'New',
  PASSED: 'Approved',
  UNDER_REVIEW: 'Under Review',
  REJECTED: 'Rejected'
});
export var AbStatusKeys = Object.keys(_objectSpread({}, AB_STATUS_VALUES)).reduce(function (acc, key) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, key));
}, {});
export var KycServiceProviderStatusValues = /*#__PURE__*/function (KycServiceProviderStatusValues) {
  KycServiceProviderStatusValues["APPROVED"] = "APPROVED";
  KycServiceProviderStatusValues["REJECTED"] = "REJECTED";
  KycServiceProviderStatusValues["WARNING"] = "WARNING";
  return KycServiceProviderStatusValues;
}({});
var defaultResponse = {
  adminComment: '',
  transactionId: '-',
  userReference: '-',
  riskScore: 100,
  idVerification: null,
  idDocument: null,
  selfieCredential: null,
  facemap: null,
  metaData: null
};
export function useAdminUpdateKycDetails() {
  var _useMutation = useMutation(function (_ref) {
      var id = _ref.id,
        adminComment = _ref.adminComment,
        approvalStatus = _ref.approvalStatus;
      var path = "".concat(GET_KYC_RESULTS_PATH, "/").concat(id, "/admin_kyc_details_update");
      var response = request(path, {
        method: 'PATCH',
        body: approvalStatus ? {
          adminComment: adminComment,
          approvalStatus: approvalStatus
        } : {
          adminComment: adminComment
        },
        // eslint-disable-next-line no-restricted-syntax -- TODO: Refactor this to use `schema`
        isExpectedResponse: function isExpectedResponse(res) {
          return res;
        },
        changeToCamelCase: true
      });
      return response;
    }),
    mutate = _useMutation.mutate,
    data = _useMutation.data,
    isSuccess = _useMutation.isSuccess,
    isError = _useMutation.isError;
  return {
    adminUpdateKycDetails: mutate,
    adminUpdateKycDetailsResponse: isSuccess ? data : null,
    isAdminUpdateKycDetailsSuccess: isSuccess,
    isAdminUpdateKycDetailsError: isError
  };
}
export function useKycTransactionDetails(kycId) {
  var _useQuery = useQuery(['kyc_transaction_details', kycId], function () {
      var path = "".concat(GET_KYC_RESULTS_PATH, "/").concat(kycId, "/view_transaction");
      return request(path, {
        // eslint-disable-next-line no-restricted-syntax -- TODO: Refactor this to use `schema`
        isExpectedResponse: function isExpectedResponse(res) {
          return res;
        },
        changeToCamelCase: true
      });
    }),
    isLoading = _useQuery.isLoading,
    isError = _useQuery.isError,
    data = _useQuery.data,
    isSuccess = _useQuery.isSuccess;
  return {
    kycTransactionDetails: isSuccess ? data : defaultResponse,
    isKycTransactionDetailsLoading: isLoading,
    isKycTransactionDetailsError: isError
  };
}